// Module
var code = "<div class=\"configureBtnBox\"> <a href=\"#\" class=\"btn blue-sharp subFormControl configureBtn\" data-bind=\"click: ShowConfigurator, css: {disabled: Disabled}, tooltip: {content: Tooltip()}, style: _style\"> <i class=\"fa fa-industry\" aria-hidden=\"true\"></i><span><!-- ko text: _labels.CONFIGURE --><!-- /ko --></span> </a> </div>";
// Exports
export default code;